import React from 'react';
import { motion } from 'framer-motion';
export function AboutJose() {
  return <section id="why-us" className="py-20 bg-white" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex justify-center" data-id="element-23">
            <div className="relative" data-id="element-24">
              <div className="absolute inset-0 bg-[#C8102E] rounded-full blur-3xl opacity-10 transform scale-110" data-id="element-25"></div>
              <img src="https://cdn.magicpatterns.com/uploads/hJguF2FSF4VF7Gq2iQCUa2/Jose_Junk_Removal_Logo_(1).png" alt="Jose's Junk Removal Logo" className="relative z-10 w-full max-w-md drop-shadow-2xl" data-id="element-26" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="prose prose-lg text-gray-600" data-id="element-27">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-6" data-id="element-28">
              WHO IS JOSE'S?
            </h2>

            <p className="text-xl font-medium text-gray-800 mb-6 border-l-4 border-[#C8102E] pl-4" data-id="element-29">
              Jose built this company on one simple belief: When someone calls
              for help, you show up. You work hard. You get it done — and you
              leave the space better than you found it.
            </p>

            <p data-id="element-30">
              He's not running some franchise operation from a call center in
              another state. He's a <strong data-id="element-31">LOCAL business owner</strong>, right
              here in Monterey County, who takes pride in every single job his
              team touches.
            </p>

            <p data-id="element-32">
              That means when you call (831) 240-7401 — you're talking to people
              who actually care. People who show up on time. People who treat
              your property with respect and handle the heavy lifting so you
              never have to.
            </p>

            <p data-id="element-33">
              Over the years, Jose's team has cleared garages, gutted
              foreclosures, demolished crumbling sheds, hauled tons of concrete,
              cleaned up after contractors, and helped families navigate some of
              the hardest moments of their lives — like clearing out a loved
              one's home after they pass.
            </p>

            <p className="font-bold text-[#1A1A1A] text-xl mt-8 uppercase tracking-wide" data-id="element-34">
              This work matters. And Jose's team shows up like it does.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}